'use client';

import { type Theme, ThemeProvider } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import type { ReactNode } from 'react';
import { theme } from '../Theme';

export const NerdWalletThemeProvider = ({
  merge,
  ...props
}: {
  merge?: Partial<Theme>;
  children?: ReactNode;
}) => <ThemeProvider theme={deepmerge(theme, merge)} {...props} />;

// Re-exporting theme for backwards compatibility
export * from '../Theme';
